import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { useSelector } from 'react-redux';

import css from '../all-classes.scss';
import Certificates from '../../../../components/certificates/certificates';
import { useCertificatesConfig } from '../../config/certificates-config';
import { useTranslations } from '../../hooks/use-translations';
import { getCertificateFilename } from '../../helpers/utils';
import { ALL_CLASSES_ID, ALL_GROUPS_ID } from '../all-classes-constants';
import { END_DATE, START_DATE } from '../../../../helpers/constants';
import UrlHelper from '../../../../helpers/url-helper';
import {
    ALL_TEACHERS,
    ALL_YEARS,
    SELECTED_TEACHER,
    SELECTED_YEAR_GROUP
} from '../../../../components/report-filters/filter-constants';
import { ALL_TEACHERS_ID } from '../../participation-constants';

const AllClassCertificates = ({
    participationData,
    newCertificatesDownloadByType,
    pastCertificatesDownloadByType,
    activeFilters,
    academicYear
}) => {
    const {
        newCertificatesConfig,
        pastCertificatesConfig
    } = useCertificatesConfig();
    const {
        certificates,
        oldCertificates,
        allClasses,
        allYearGroups
    } = useTranslations();
    const isAdmin = useSelector((state) => state.isAdmin);
    const selectedYearGroupId = activeFilters[SELECTED_YEAR_GROUP].id;
    const selectedTeacherId = activeFilters[SELECTED_TEACHER].id;
    const certificateProps = {
        classroomId: ALL_CLASSES_ID,
        startDate:
            UrlHelper.getQueryParamValue(START_DATE) || academicYear.startDate,
        endDate: UrlHelper.getQueryParamValue(END_DATE) || academicYear.endDate,
        groupId: ALL_GROUPS_ID,
        isForDownload: true,
        ...(selectedYearGroupId !== ALL_YEARS && {
            yearGroupEnum: selectedYearGroupId
        }),
        teacherUserProfileId:
            selectedTeacherId === ALL_TEACHERS
                ? ALL_TEACHERS_ID
                : selectedTeacherId
    };
    const isAllYearGroupCertificate =
        isAdmin && selectedYearGroupId === ALL_YEARS;
    return (
        <div className={css.certificates}>
            <Certificates
                config={newCertificatesConfig}
                heading={certificates}
                certificates={
                    participationData && participationData.newCertificate
                }
                handleCertificateDownloadClick={(payload) => {
                    const { certificatesCount, certificateTypeName } = payload;
                    newCertificatesDownloadByType({
                        ...payload,
                        fileNameOverride: getCertificateFilename({
                            certificatesCount,
                            certificateTypeName,
                            title: isAllYearGroupCertificate
                                ? allYearGroups
                                : allClasses,
                            prefixCertificate: false
                        })
                    });
                }}
                {...certificateProps}
            />
            <Certificates
                config={pastCertificatesConfig}
                heading={oldCertificates}
                isOldCertificates
                certificates={
                    participationData && participationData.certificates
                }
                handleCertificateDownloadClick={(payload) => {
                    const { certificatesCount, certificateTypeName } = payload;
                    pastCertificatesDownloadByType({
                        ...payload,
                        fileNameOverride: getCertificateFilename({
                            certificatesCount,
                            certificateTypeName,
                            title: isAllYearGroupCertificate
                                ? allYearGroups
                                : allClasses,
                            prefixCertificate: false
                        })
                    });
                }}
                {...certificateProps}
            />
        </div>
    );
};

AllClassCertificates.propTypes = {
    participationData: PropTypes.object || null,
    newCertificatesDownloadByType: PropTypes.func,
    pastCertificatesDownloadByType: PropTypes.func,
    academicYear: PropTypes.object.isRequired,
    activeFilters: PropTypes.object.isRequired
};

export default styleable(css)(AllClassCertificates);



// WEBPACK FOOTER //
// ./containers/participation/all-classes/components/all-class-certificates.js